import type { ExchangeRate } from './types'
import { MockExchangeRateProvider } from './mockProvider'
import { ApiExchangeRateProvider } from './apiProvider'
import type { ExchangeRateProvider } from './types'

let provider: ExchangeRateProvider | null = null

export function getExchangeProvider(): ExchangeRateProvider {
  if (provider) return provider

  const mode = import.meta.env.VITE_EXCHANGE_PROVIDER ?? 'mock'
  provider = mode === 'api' ? new ApiExchangeRateProvider() : new MockExchangeRateProvider()
  return provider
}

export function setExchangeProvider(next: ExchangeRateProvider): void {
  provider = next
}

export type { ExchangeRate, ExchangeRateProvider }
